import StatusColorful from "../../../Components/Table/Components/StatusColorful";

const displayOptionalValue = (value) =>
  value === null ||
  value === undefined ||
  String(value).trim() === "" ||
  String(value).trim() === "-"
    ? "ندارد"
    : value;

export default function WithdrawGridCard({
  reqAmount,
  dateReq,
  dateDone,
  status,
}) {
  const statusProps = {
    approved: { text: "تکمیل شده", color: "green" },
    pending: { text: "در انتظار", color: "yellow" },
    rejected: { text: "رد شده", color: "red" },
  }[status] ?? { text: "نامشخص", color: "gray" };

  return (
    <article className="w-full rounded-2xl p-2.5 flex flex-col gap-3 bg-gradient-to-br from-white/10 to-white/5 border border-white/10">
      <div className="w-full flex items-start justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            مبلغ درخواستی
          </span>
          <span className="text-sm text-zi-text-light dark:text-zi-text-dark [direction:ltr]">
            {displayOptionalValue(reqAmount)}
          </span>
        </div>
        <StatusColorful
          text={statusProps.text}
          className="w-fit"
          color={statusProps.color}
          containerClassName="!w-fit"
        />
      </div>
      <div className="w-full flex items-center justify-between gap-2.5">
        <div className="flex flex-col gap-0 items-start">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            تاریخ درخواست
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {displayOptionalValue(dateReq)}
          </span>
        </div>
        <div className="flex flex-col gap-0 items-end">
          <span className="text-xs font-thin text-zi-text-light/50 dark:text-zi-text-dark/50">
            تاریخ تکمیل
          </span>
          <span className="text-xs text-zi-text-light/75 dark:text-zi-text-dark/75 [direction:ltr]">
            {displayOptionalValue(dateDone)}
          </span>
        </div>
      </div>
    </article>
  );
}
